import { type PropsWithChildren, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { Environment } from '@src/environment';

export function GTMWrapper({ children }: PropsWithChildren) {
  useEffect(() => {
    TagManager.initialize({ gtmId: Environment.GTM_ID });
  }, []);

  return children;
}
